module.exports = __webpack_public_path__ + "img/weichat.dc26a8bd.svg";